import { takeLatest, put, take, race } from "redux-saga/effects";
import i18next from "i18next";
import { GET_DATA, POST_DATA } from "actions/apiOperations.js";
import { addNotification } from "notificationStore";
import { 
  barcodeQtyImportActions,
  requestFileUpload,
  buyplanBarcodeQtyImportRequest
} from "actions/barcodeQtyImportActions.js";


export const requestFileUploadUrl = function*(action) {
  const params = action.payload;
  const url = params['stock_model_id']
    ? `/api/stock_models/${params['stock_model_id']}/file_upload_url.json`
    : `/api/buyplans/${params['buyplan_id']}/file_upload_url.json`

  yield put({
    type: GET_DATA,
    path: url,
    actions: {
      success: barcodeQtyImportActions.fileUploadUrlSuccess,
      failure: barcodeQtyImportActions.fileUploadUrlFailure
    },
    params
  });

  const { success, failure } = yield race({
    success: take(barcodeQtyImportActions.fileUploadUrlSuccess),
    failure: take(barcodeQtyImportActions.fileUploadUrlFailure)
  });

  if (success) {
    params["presignedUrl"] = success.payload.data

    yield put(requestFileUpload(params));
  }

  if (failure) {
    addNotification({ type: "danger", message: i18next.t("barcode.fileUploadFailed") });
  }
};

export const requestFileUploadAsync = function*(action) {
  const { presignedUrl, file, ...params } = action.payload;

  try {
    const response = yield fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (response.ok) {
      yield put(buyplanBarcodeQtyImportRequest(params))
    }
    else {
      addNotification({ type: "danger", message: i18next.t("barcode.fileUploadFailed") });
    }
  } catch (error) {
    // eslint-disable-next-line
    console.error('Upload error:', error);
    addNotification({ type: "danger", message: i18next.t("barcode.fileUploadFailed") });
  }
};

export const requestBuyplanBarcodeQtyImportAsync = function*(action) {
  const params = action.payload;
  const url = params['stock_model_id']
    ? `/api/stock_models/${params['stock_model_id']}/items/barcode_qty_import.json`
    : `/api/buyplans/${params['buyplan_id']}/items/barcode_qty_import.json`;

  yield put({
    type: POST_DATA,
    path: url,
    actions: {
      success: barcodeQtyImportActions.buyplanBarcodeQtyImportSuccess,
      failure: barcodeQtyImportActions.buyplanBarcodeQtyImportFailure
    },
    params
  });

  const { success, failure } = yield race({
    success: barcodeQtyImportActions.buyplanBarcodeQtyImportSuccess,
    failure: barcodeQtyImportActions.buyplanBarcodeQtyImportFailure
  });

  if (success) {
    addNotification({ message: i18next.t("barcode.fileUploadSuccess") });
  }
  if (failure) {
    addNotification({ type: "danger", message: i18next.t("barcode.fileUploadFailed") });
  }
};

export const watchRequestFileUploadUrl = function*() {
  yield takeLatest(barcodeQtyImportActions.requestFileUploadUrl, requestFileUploadUrl);
};

export const watchRequestFileUpload = function*() {
  yield takeLatest(barcodeQtyImportActions.requestFileUpload, requestFileUploadAsync);
};

export const watchBuyplanBarcodeQtyImportRequest = function*() {
  yield takeLatest(barcodeQtyImportActions.buyplanBarcodeQtyImportRequest, requestBuyplanBarcodeQtyImportAsync);
};
